import HistoryIcon from '@mui/icons-material/History'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

interface Props {
  requestId: string
}

export const AuditLogMenuItem = ({ requestId }: Props) => {
  const { t } = useTranslation('requests')

  return (
    <MenuItem component={Link} href={`/requests/detail/${requestId}/audit-log`}>
      <ListItemIcon>
        <HistoryIcon />
      </ListItemIcon>
      <ListItemText>{t('manage-request.audit-log')}</ListItemText>
    </MenuItem>
  )
}
